import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";

import FormInputLabel from "./FormInputLabel";
import { isSameCalendarDay, startOfDay } from "../utils/dateFormatters";

export type FormDateTimeInputProps = {
    label: string
    value: Date | null
    onChange: (value: Date | null) => void
    minDate?: Date
    maxDate?: Date
    required?: boolean
    hideHelpText?: boolean
    helperText?: string
    tooltip?: string
    name: string
}

const FormDateTimeInput = ({
    label,
    value,
    onChange,
    name,
    minDate,
    maxDate,
    required,
    tooltip
}: FormDateTimeInputProps) => {
    const pickerMinDate = minDate ? startOfDay(minDate) : undefined;
    const referenceDate = pickerMinDate ?? startOfDay(new Date());

    const handleChange = (newValue: Date | null) => {
        if (!newValue) {
            onChange(null);
            return;
        }

        if (!value || !isSameCalendarDay(value, newValue)) {
            onChange(startOfDay(newValue));
            return;
        }

        onChange(newValue);
    };

    return (
        <div className="w-full space-y-2">
            <FormInputLabel tooltipText={tooltip} required={required}>{label}</FormInputLabel>
            <DateTimePicker
                format="dd/MM/yy hh:mm aa"
                minutesStep={5}
                ampm
                value={value}
                name={name}
                referenceDate={referenceDate}
                onOpen={() => {
                    if (!value && pickerMinDate) {
                        onChange(pickerMinDate);
                    }
                }}
                onChange={handleChange}
                minDate={pickerMinDate}
                maxDate={maxDate}
                slotProps={{
                    textField: {
                        required,
                        fullWidth: true,
                        variant: "outlined",
                        name,
                    },
                }}
            />
        </div>
    );
};

export default FormDateTimeInput;
